import {
  ActivationModel,
  AddressInsuranceModel,
  ContactInsuranceModel,
  CustomerInsuranceModel,
  IndividualModel,
  PolicyModel,
  ServiceActivationModel,
} from '@/app/shared/models';
import { HttpService } from '@/app/shared/services/http.service';
import { env } from '@/environments';
import { refsService } from '../../refs.service';

export class PolicyService extends HttpService {
  // public async loadPolicyList(
  //   Filter?: string,
  //   limit = 999
  // ): Promise<PolicyModel[]> {
  //   return await this.get<PolicyModel[]>(`${env.insuranceUri}/Policies`, {
  //     params: { Filter, limit },
  //     headers: { tenantId: refsService.modules.company.account.Id },
  //   }).then(({ data }) => data);
  // }
  public async getPolicyById(policyId: string): Promise<PolicyModel> {
    return await this.get<PolicyModel>(
      `${env.insuranceUri}/Policies/${policyId}`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async updatePolicy(
    policyId: string,
    policy: PolicyModel
  ): Promise<void> {
    await this.put<void, PolicyModel>(
      `${env.insuranceUri}/Policies/${policyId}`,
      policy,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async getCustomerByPolicyId(
    policyId: string
  ): Promise<CustomerInsuranceModel> {
    return await this.get<CustomerInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/customer`
    ).then(({ data }) => data);
  }
  public async updateCustomer(
    policyId: string,
    customer: CustomerInsuranceModel
  ): Promise<void> {
    await this.put<void, CustomerInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/customer`,
      customer,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async updateCustomerAddress(
    policyId: string,
    addressId: string,
    address: AddressInsuranceModel
  ): Promise<void> {
    await this.put<void, AddressInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/customer/addresses/${addressId}`,
      address,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async createCustomerAddress(
    policyId: string,
    address: AddressInsuranceModel
  ): Promise<void> {
    await this.post<void, AddressInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/customer/addresses`,
      address,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async updateCustomerContact(
    policyId: string,
    contactId: string,
    contact: ContactInsuranceModel
  ): Promise<void> {
    await this.put<void, ContactInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/customer/contacts/${contactId}`,
      contact,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async createCustomerContact(
    policyId: string,
    contact: ContactInsuranceModel
  ): Promise<void> {
    await this.post<void, ContactInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/customer/contacts`,
      contact,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }

  public async resendCertificateByPolicyId(
    policyId: string,
    payload: object
  ): Promise<{ Id: string }> {
    return await this.put<{ Id: string }, object>(
      `${env.insuranceUri}/Policies/${policyId}/certificate`,
      payload,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }

  public async getActivationById(
    policyId: string,
    activationId: string
  ): Promise<ActivationModel> {
    return await this.get<ActivationModel>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async getListServiceActivationById(
    policyId: string,
    activationId: string
  ): Promise<ServiceActivationModel[]> {
    return await this.get<ServiceActivationModel[]>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/serviceActivations`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }

  public async createIndividual(
    policyId: string,
    activationId: string,
    individual: IndividualModel
  ): Promise<IndividualModel> {
    return await this.post<IndividualModel, IndividualModel>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/individuals`,
      individual,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async updateIndividual(
    policyId: string,
    activationId: string,
    id: string,
    individual: IndividualModel
  ): Promise<IndividualModel> {
    return await this.put<IndividualModel, IndividualModel>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/individuals/${id}`,
      individual,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async deleteIndividual(
    policyId: string,
    activationId: string,
    id: string
  ): Promise<void> {
    await this.delete(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/individuals/${id}`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async updateIndividualAddress(
    policyId: string,
    activationId: string,
    individualId: string,
    addressId: string,
    address: AddressInsuranceModel
  ): Promise<void> {
    await this.put<void, AddressInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/Individuals/${individualId}/addresses/${addressId}`,
      address,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async createIndividualAddress(
    policyId: string,
    activationId: string,
    individualId: string,
    address: AddressInsuranceModel
  ): Promise<void> {
    await this.post<void, AddressInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/Individuals/${individualId}/addresses`,
      address,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async updateIndividualContact(
    policyId: string,
    activationId: string,
    individualId: string,
    contactId: string,
    contact: ContactInsuranceModel
  ): Promise<void> {
    await this.put<void, ContactInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/Individuals/${individualId}/Contacts/${contactId}`,
      contact,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
  public async createIndividualContact(
    policyId: string,
    activationId: string,
    individualId: string,
    contact: ContactInsuranceModel
  ): Promise<void> {
    await this.post<void, ContactInsuranceModel>(
      `${env.insuranceUri}/Policies/${policyId}/activations/${activationId}/Individuals/${individualId}/Contacts`,
      contact,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    );
  }
}
